import React from "react"
import { Link } from "react-router-dom"


const SrNo = cell => {
  return (
    <Link to="#" className="text-body fw-bold">
      {cell.value ? cell.value : ""}
    </Link>
  )
}
const IncomeRange = cell => {
  return cell.value ? cell.value : ""
}


export {SrNo, IncomeRange}